import * as R from 'ramda'

import { getLanguages } from 'utils/languages'
import { getFields } from './tabs/Competencies/model'
import { getModulesOrder } from './tabs/Modules/model'

const modulesOrder = getModulesOrder()

export const mapInternalStateToPayload = state => {
  const {
    absence,
    category,
    competencies,
    description,
    languages,
    modules,
    position,
    productivity,
    template,
    turnover,
    positions,
    department,
    members_with_access,
  } = state

  const payload = {
    category: R.prop('value', category),
    department: department.value,
    description,
    ...(positions && { positions }),
    interview_template: !R.isNil(template) ? R.prop('value', template) : null,
    languages: R.map(({ value }) => value, languages),
    modules: R.reduce(
      (acc, { name, ...rest }) => ({
        ...acc,
        [name === 'ability' ? 'gma' : name]: R.prop(name)(rest),
      }),
      {},
      modules,
    ),
    name: position,
    profile: {
      categories: R.reduce(
        (acc, { name, ...rest }) => ({ ...acc, [name]: R.prop(name)(rest) }),
        {},
        competencies,
      ),
      outputVariables: {
        isProductivityEnabled: !!productivity,
        isSicknessAbsenceEnabled: !!absence,
        isTurnoverEnabled: !!turnover,
        productivity: !!productivity,
        sicknessAbsence: !!absence,
        turnover: !!turnover,
      },
    },
    ...(members_with_access && { members_with_access }),
  }

  return payload
}

export const mapTemplateToInternalState = state => {
  const {
    category,
    description = '',
    interview_template,
    languages = [],
    modules = {},
    name = '',
    positions,
    profile: {
      categories,
      outputVariables: {
        isProductivityEnabled,
        isSicknessAbsenceEnabled,
        isTurnoverEnabled,
      } = {},
    } = {},
    department,
    members_with_access,
  } = state ?? {}

  const noPriorityBool =
    !isProductivityEnabled && !isSicknessAbsenceEnabled && !isTurnoverEnabled

  const formState = {
    absence: isSicknessAbsenceEnabled,
    category: category ? { label: category, value: category } : null,
    department: { label: department?.name, value: department?.id },
    competencies: !R.isEmpty(categories)
      ? R.pipe(
          R.toPairs,
          R.sort(R.comparator(R.lt)),
          R.map(([name, value]) => ({ [name]: value, name })),
        )(categories)
      : getFields(),
    description,
    languages: R.equals(R.length(languages), 0)
      ? getLanguages()
      : R.map(key => R.find(R.propEq('value', key), getLanguages()), languages),
    modules: R.pipe(
      R.toPairs,
      R.sort(
        ([current], [next]) =>
          R.indexOf(current, modulesOrder) - R.indexOf(next, modulesOrder),
      ),
      R.map(([key, value]) => {
        const name = key === 'gma' ? 'ability' : key

        return { [name]: value, name }
      }),
    )(modules),
    position: name,
    ...(positions && { positions }),
    productivity: isProductivityEnabled,
    ...(R.and(interview_template, R.prop('interview', modules)) && {
      template: {
        label: interview_template,
        value: interview_template,
      },
    }),
    ...(members_with_access && {
      members_with_access: members_with_access?.map(member => member.id),
    }),
    turnover: isTurnoverEnabled,
    noPriority: noPriorityBool,
  }

  return formState
}
